export { default } from "./ListHistoricoVentasMes";
